import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Geolocation } from '@ionic-native/geolocation';
declare var google: any;

/*
  Generated class for the MapsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class MapsProvider {
  public map;
  constructor(public http: HttpClient, private geolocation: Geolocation) {

  }

  getCurrentLocation(mapRef, hubs) {
    this.geolocation.getCurrentPosition().then( res => {
      const styledMapType = new google.maps.StyledMapType(
        [
          {
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#f5f5f5"
              }
            ]
          },
          {
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#616161"
              }
            ]
          },
          {
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "color": "#f5f5f5"
              }
            ]
          },
          {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#bdbdbd"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#eeeeee"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#757575"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#e5e5e5"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#9e9e9e"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#ffffff"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#757575"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#dadada"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#616161"
              }
            ]
          },
          {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#9e9e9e"
              }
            ]
          },
          {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#e5e5e5"
              }
            ]
          },
          {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#eeeeee"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#c9c9c9"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#9e9e9e"
              }
            ]
          }
        ], {name: 'Styled Map'}
      );
       this.map = new google.maps.Map(mapRef, {
          center:{lat:res.coords.latitude, lng:res.coords.longitude},
          mapTypeId: 'roadmap',
          zoom:10,
         streetViewControl: false,
         mapTypeControl: false,
         styles: [
           {
             "elementType": "geometry",
             "stylers": [
               {
                 "color": "#f5f5f5"
               }
             ]
           },
           {
             "elementType": "labels.icon",
             "stylers": [
               {
                 "visibility": "off"
               }
             ]
           },
           {
             "elementType": "labels.text.fill",
             "stylers": [
               {
                 "color": "#616161"
               }
             ]
           },
           {
             "elementType": "labels.text.stroke",
             "stylers": [
               {
                 "color": "#f5f5f5"
               }
             ]
           },
           {
             "featureType": "administrative.land_parcel",
             "elementType": "labels.text.fill",
             "stylers": [
               {
                 "color": "#bdbdbd"
               }
             ]
           },
           {
             "featureType": "poi",
             "elementType": "geometry",
             "stylers": [
               {
                 "color": "#eeeeee"
               }
             ]
           },
           {
             "featureType": "poi",
             "elementType": "labels.text.fill",
             "stylers": [
               {
                 "color": "#757575"
               }
             ]
           },
           {
             "featureType": "poi.business",
             "stylers": [
               {
                 "visibility": "off"
               }
             ]
           },
           {
             "featureType": "poi.park",
             "elementType": "geometry",
             "stylers": [
               {
                 "color": "#e5e5e5"
               }
             ]
           },
           {
             "featureType": "poi.park",
             "elementType": "labels.text",
             "stylers": [
               {
                 "visibility": "off"
               }
             ]
           },
           {
             "featureType": "poi.park",
             "elementType": "labels.text.fill",
             "stylers": [
               {
                 "color": "#9e9e9e"
               }
             ]
           },
           {
             "featureType": "road",
             "elementType": "geometry",
             "stylers": [
               {
                 "color": "#ffffff"
               }
             ]
           },
           {
             "featureType": "road.arterial",
             "elementType": "labels.text.fill",
             "stylers": [
               {
                 "color": "#757575"
               }
             ]
           },
           {
             "featureType": "road.highway",
             "elementType": "geometry",
             "stylers": [
               {
                 "color": "#dadada"
               }
             ]
           },
           {
             "featureType": "road.highway",
             "elementType": "labels.text.fill",
             "stylers": [
               {
                 "color": "#616161"
               }
             ]
           },
           {
             "featureType": "road.local",
             "elementType": "labels.text.fill",
             "stylers": [
               {
                 "color": "#9e9e9e"
               }
             ]
           },
           {
             "featureType": "transit.line",
             "elementType": "geometry",
             "stylers": [
               {
                 "color": "#e5e5e5"
               }
             ]
           },
           {
             "featureType": "transit.station",
             "elementType": "geometry",
             "stylers": [
               {
                 "color": "#eeeeee"
               }
             ]
           },
           {
             "featureType": "water",
             "elementType": "geometry",
             "stylers": [
               {
                 "color": "#c9c9c9"
               }
             ]
           },
           {
             "featureType": "water",
             "elementType": "labels.text.fill",
             "stylers": [
               {
                 "color": "#9e9e9e"
               }
             ]
           }
         ]


        });
       /*this.map.mapTypes.set('styled_map', styledMapType);
       this.map.setMapTypeId('styled_map');*/
     // const location = new google.maps.LatLng(res.coords.latitude, res.coords.longitude);
      this.addMarker(new google.maps.LatLng(res.coords.latitude, res.coords.longitude), this.map);
     // console.log(hubs)
      this.addHubsToMap(hubs);
    }).catch( error => {
      console.log(error)
    })
  }

  addMarker(position, map) {
    return new google.maps.Marker({
      position,
      map,
      icon:'https://cdn.zeplin.io/5c6d4f6b6f0f43465e306384/assets/F0B25DA8-A76C-4387-A611-3B7FA2E72F3C.svg'
    })
  }


  addHubsToMap(hubs) {

    hubs.forEach((hub) => {
      const[lat, lng] = hub.coordinates.split(',') ;
      const marker = new google.maps.Marker({
        map:this.map,
        position: new google.maps.LatLng(Number(lat), Number(lng)),
        title: hub.name,
        // icon: 'https://cdn.zeplin.io/5c6d4f6b6f0f43465e306384/assets/DB4B568B-6BCE-4E0A-A6E0-CA264C0C10B7.svg'

      });

      const infoWindow = new google.maps.InfoWindow();
      // Allow each marker to have an info window
      google.maps.event.addListener(marker, 'click', () => {
        infoWindow.setContent(`<strong style="text-align:center">${hub.name}</strong><br> ${hub.address}`);
        infoWindow.open(this.map, marker);
      })
    })
  }

}



// WEBPACK FOOTER //
// ./src/providers/maps/maps.ts